'use strict';

/**
 *
 * @category   View
 * @module     settings
 * @copyright  Copyright (c) 2015, COLIDO (http://www.colido.net)
 * @author     Cengiz Mardin <cm@humans.am>
 */
var ColidoLayoutView = require('base/Colido.LayoutView');
var FileUploadView = require('modules/global/views/components/file-upload');
var template = require('modules/settings/templates/partials/profile/upload.hbs');

var UploadComponent = ColidoLayoutView.extend({
    template: template,
    fileSelectView: null,

    ui: {
        container: '.form-component',
        selectedFile: '#selected-file',
    },

    regions: {
        'fileSelectRegion': '#subregion-file-select',
    },

    childEvents: {
        'upload:state:selected': 'onUploadFileSelected',
        'upload:state:finished': 'onUploadFinished',
        'upload:state:error': 'onUploadError',
    },

    onRender: function() {
        this.fileSelectView = new FileUploadView({
            uploadHandler: App.getApiUrl('/assets/'),
            imagesOnly: true,
        });

        this.fileSelectRegion.show(this.fileSelectView);
    },

    onUploadFileSelected: function(childView, event) {
        var file = _.first(event.currentTarget.files);
        this.ui.selectedFile.html(file.name);
        this.triggerMethod('component:upload:file:selected', event);
        this.fileSelectView.triggerMethod('action:upload:file');
    },

    onUploadFinished: function(childView, event) {
        this.ui.container.attr('data-state', 'finished');
        this.triggerMethod('upload:state:finished', event);
    },

    onUploadError: function(childView, event) {
        this.triggerMethod('component:upload:state:error', event);
    },
});

module.exports = UploadComponent;